import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Fade from '@material-ui/core/Fade'
import CircularProgress from '@material-ui/core/CircularProgress'
import CardHeader from '@material-ui/core/CardHeader'
import moment from 'moment'
import { WID } from '../../../constants/Language'
import Word from '../../../containers/Common/Word'

const styles = theme => ({
  circular: {
    margin: 'auto',
  },
  record: {
    padding: `${theme.spacing.unit}px 0`,
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  },
  payment: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 80px',
    alignItems: 'center',
    padding: `${theme.spacing.unit / 2}px 0`,
  },
  payer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    color: theme.palette.grey[500],
    padding: `${theme.spacing.unit / 2}px 0`,
  },
  name: {
    paddingLeft: theme.spacing.unit,
    wordBreak: 'break-word',
  }
})

class PaymentCard extends React.Component {
  state = {
    payments: undefined,
  }
  componentDidMount() {
    var payments
    payments = []
    this.props.fetch()
    .then(response => {
      if (response.message !== "success") {
        return
      }
      payments = response.records.map(record => {
        return {
          ...record,
          timestamp: new Date(record.timestamp)
        }
      })
      payments.sort((a, b) => {
        return a.timestamp.getTime() < b.timestamp.getTime() ? 1 : -1
      })
      this.setState({ payments })
    })
  }

  render() {
    const { classes } = this.props
    const { payments } = this.state
    return (
      <React.Fragment>
        <Fade in={!Boolean(payments)}>
          <CircularProgress className={classes.circular} style={{ display: !Boolean(payments) ? 'block' : 'none' }}/>
        </Fade>
        <Fade in={Boolean(payments)}>
          <Card>
            <CardHeader title={(<Word wid={WID.PAYMENT_CARD.CARD_TITLE}/>)}/>
            <CardContent>
              {payments && payments.map((payment, index) => {
                return (
                  <div key={index} className={classes.record}>
                    <div key={index} className={classes.payment}>
                      <Typography>{moment(payment.timestamp).format('YYYY/MM/DD HH:mm')}</Typography>
                      <Typography className={classes.name} variant="subheading">{payment.type}</Typography>
                      <Typography align='right'>{`${payment.value} ${payment.currency}`}</Typography>
                    </div>
                    <div className={classes.payer}>
                      <Typography color='inherit'><Word wid={WID.PAYMENT_CARD.PAYER}/>{`: ${payment.payerName} - ${payment.email}`}</Typography>
                    </div>
                  </div>
                )
              })}
            </CardContent>
          </Card>
        </Fade>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(PaymentCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/components/PaymentCard.js